import { httpService } from '@/services/HttpService';

class AccountService {
  getBalance(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/credits/balance`, {}, { isErrorSuppressed: true });
  }
}

export const accountService = new AccountService();
